import { absolutePath } from "../absolutePath";

interface EntityParams {
  browse?: boolean;
  category?: string;
  members_only?: boolean;
  query?: string;
}

export const entities = {
  index: ({
    query = "",
    category = "",
    members_only = false,
    browse = false,
  }: EntityParams) =>
    absolutePath("masquerading/entities", {
      query,
      category,
      members_only,
      browse,
    }),
};
